import { v4 as uuid } from 'uuid';

export const generateRequestID = () => {
  return uuid().replace(/-/g, '');
};
